export default __webpack_public_path__ + "static/simple-pie-c2f4cb07860e1d11ddddfdbb196219df.png";